import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import cx from 'classnames';
import { widgetLoadingIdSelector } from 'app/store/selectors/widgets';
import DashboardLayout from 'app/pages/Project/ProductionManagement/Dashboards/DashboardLayout/DashboardLayout';
import { WIDGET_TYPES } from 'app/pages/Project/ProductionManagement/Dashboards/constants';
import classes from 'app/pages/Project/ProductionManagement/Dashboards/DashboardWidgets/styles.scss';
import CostsWidget from 'app/pages/Project/ProductionManagement/Dashboards/Widgets/CostsWidget/CostsWidget';
import GlobalStatusWidget from 'app/pages/Project/ProductionManagement/Dashboards/Widgets/GlobalStatusWidget/GlobalStatusWidget';
import GlobalCostsWidget from 'app/pages/Project/ProductionManagement/Dashboards/Widgets/GlobalCostsWidget/GlobalCostsWidget';
import StatusWidget from 'app/pages/Project/ProductionManagement/Dashboards/Widgets/StatusWidget/StatusWidget';
import WidgetContainer from '../Widgets/WidgetContainer/WidgetContainer';
import { getWidgetConfigRecursively } from 'app/pages/Project/Settings/Dashboards/utils';
const DashboardWidgets = (props) => {
    const { widgets, allEpisodes, stepProjects, progressionStatus, dashboardLayout, nested, allLayouts, activeEpisodesByWidget, setActiveEpisodesByWidget, saveDashboardLayoutLocally, fromSettings, } = props;
    const widgetLoadingId = useSelector(widgetLoadingIdSelector);
    const onLayoutChange = (newLayouts) => {
        saveDashboardLayoutLocally === null || saveDashboardLayoutLocally === void 0 ? void 0 : saveDashboardLayoutLocally(newLayouts);
    };
    function generateDOM() {
        return dashboardLayout.map((layout) => {
            const widget = widgets.find((wid) => wid.id === layout.i);
            if (!widget)
                return;
            const widgetIsContainer = (widget === null || widget === void 0 ? void 0 : widget.widgetType) === WIDGET_TYPES.CONTAINER;
            const childsWidgets = widgets.filter((wid) => wid.parent === widget.id);
            const childsWidgetsIds = childsWidgets.map((wid) => wid.id);
            const childLayout = allLayouts.filter((lay) => childsWidgetsIds.includes(lay.i));
            const isLoading = widgetLoadingId === widget.id;
            const containerHasEpisodeWidget = widgetIsContainer &&
                childsWidgets.some((wid) => [WIDGET_TYPES.CONTAINER, WIDGET_TYPES.EPISODE_COSTS, WIDGET_TYPES.EPISODE_STATUS].includes(wid.widgetType));
            const container = (_jsx("div", { className: cx(classes.widgetContainer, isLoading && classes.blur), children: _jsx(WidgetContainer, { widget: widget, allEpisodes: allEpisodes, activeEpisodesByWidget: activeEpisodesByWidget, setActiveEpisodesByWidget: setActiveEpisodesByWidget, isLoading: isLoading, displayActionButton: containerHasEpisodeWidget, children: _jsx("div", { children: _jsx(DashboardWidgets, { dashboardLayout: childLayout, allLayouts: allLayouts, nested: true, widgets: widgets, allEpisodes: allEpisodes, stepProjects: stepProjects, progressionStatus: progressionStatus, activeEpisodesByWidget: activeEpisodesByWidget, setActiveEpisodesByWidget: setActiveEpisodesByWidget, saveDashboardLayoutLocally: saveDashboardLayoutLocally }) }) }) }, layout.i));
            // sub container
            if (widgetIsContainer && nested && widget.parent) {
                return container;
            }
            // container
            if (widgetIsContainer && !nested && !widget.parent) {
                return container;
            }
            const { assetType, steps, episodes: displayedEpisodes, } = getWidgetConfigRecursively({
                widget,
                widgets,
                keys: ['assetType', 'steps', 'episodes'],
            });
            const taskWidget = (_jsx("div", { children: _jsx(StatusWidget, { allEpisodes: allEpisodes, steps: steps, assetType: assetType, displayedEpisodes: displayedEpisodes, widget: widget, stepProjects: stepProjects, progressionStatus: progressionStatus, activeEpisodesByWidget: activeEpisodesByWidget, setActiveEpisodesByWidget: setActiveEpisodesByWidget }) }, layout.i));
            const costsWidget = (_jsx("div", { children: _jsx(CostsWidget, { steps: steps, allEpisodes: allEpisodes, displayedEpisodes: displayedEpisodes, widget: widget, activeEpisodesByWidget: activeEpisodesByWidget, setActiveEpisodesByWidget: setActiveEpisodesByWidget }) }, layout.i));
            const globalStatusWidget = (_jsx("div", { children: _jsx(GlobalStatusWidget, { steps: steps, widget: widget, stepProjects: stepProjects, progressionStatus: progressionStatus }) }, layout.i));
            const globalCostsWidget = (_jsx("div", { children: _jsx(GlobalCostsWidget, { steps: steps, widget: widget }) }, layout.i));
            // widget with no parent
            if (!widgetIsContainer && !props.nested && !widget.parent) {
                switch (widget.widgetType) {
                    case WIDGET_TYPES.EPISODE_STATUS:
                        return taskWidget;
                    case WIDGET_TYPES.EPISODE_COSTS:
                        return costsWidget;
                    case WIDGET_TYPES.GLOBAL_STATUS:
                        return globalStatusWidget;
                    case WIDGET_TYPES.GLOBAL_COSTS:
                        return globalCostsWidget;
                    default:
                        return _jsx(_Fragment, {});
                }
            }
            // nested widget (= child of a container)
            if (!widgetIsContainer && props.nested) {
                switch (widget.widgetType) {
                    case WIDGET_TYPES.EPISODE_STATUS:
                        return taskWidget;
                    case WIDGET_TYPES.EPISODE_COSTS:
                        return costsWidget;
                    case WIDGET_TYPES.GLOBAL_STATUS:
                        return globalStatusWidget;
                    case WIDGET_TYPES.GLOBAL_COSTS:
                        return globalCostsWidget;
                    default:
                        return _jsx(_Fragment, {});
                }
            }
        });
    }
    return (_jsx(DashboardLayout, { layout: dashboardLayout, nested: nested, onLayoutChange: onLayoutChange, fromSettings: fromSettings, children: generateDOM() }));
};
export default DashboardWidgets;
